/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FolderFileFilePermissionControllerTransferChildRelations200ResponseData } from './folderFileFilePermissionControllerTransferChildRelations200ResponseData';


export interface FolderFileFilePermissionControllerTransferChildRelations200Response { 
    statusCode?: number;
    success?: boolean;
    message?: string;
    data?: FolderFileFilePermissionControllerTransferChildRelations200ResponseData;
}

